/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visibilityprivateshort2Inputs */

const en_visibilityprivateshort2 = /** @type {(inputs: Visibilityprivateshort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private`)
};

const de_visibilityprivateshort2 = /** @type {(inputs: Visibilityprivateshort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privat`)
};

/**
* | output |
* | --- |
* | "Private" |
*
* @param {Visibilityprivateshort2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const visibilityprivateshort2 = /** @type {((inputs?: Visibilityprivateshort2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visibilityprivateshort2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_visibilityprivateshort2(inputs)
	return de_visibilityprivateshort2(inputs)
});
export { visibilityprivateshort2 as "visibilityPrivateShort" }